import { EditablePicture } from '~components/generic/editable-picture/EditablePicture/EditablePicture';
import entityContainerConnector from '~components/generic/entityContainerConnector';
export default entityContainerConnector(EditablePicture);
